module.exports = __webpack_public_path__ + "static/media/teamwork-goal.7f35ed86.jpg";